import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
const stepperData = ["内容入力", "入力内容確認", "機構へ提出"];

const infoModalMessage = `【従業状況の登録確認】<
　中小企業退職金共済契約締結届の提出にあたって、事前に従業状況を最新の状況に更新いただく必要があります。<
　従業状況が最新になっていない場合には、最初に従業状況の更新をお願いします。<
　従業状況の更新が完了している場合は「次へ」ボタンをクリックしてください。<
　完了していない場合は「従業状況の更新」ボタンをクリックしてください。<
　なお、当該手続きによる解除は退職手当金が支給されません。`;

const contextText = `入力された解除年月日以降の退職(予定)年月日・異動情報(配置換え)が入力されている職員が存在します。<
このまま契約解除の申請を進めると、退職(予定)年月日・異動情報(配置換え)が削除されますがよろしいですか。`;

const infoHeadTitleList: any[] = [
  {
    headTitle: (
      <>
        施設名称
        <TkHelpIcon helpMessage="登録されている施設等の名称です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        施設種類
        <TkHelpIcon helpMessage="登録されている施設等の施設種類・サービス種類です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        加入職員数
        <TkHelpIcon helpMessage="現時点の各施設・事業ごとの加入職員数です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        従業状況確認
        <TkHelpIcon helpMessage="現在の職員の従業状況が確認できます。契約解除にあたって、職員の従業状況が最新の状態であるか確認してください。" />
      </>
    ),
    dontNeedSort: true,
  },
  {
    headTitle: (
      <>
        直近３ヶ月の退職者の証明書
        <TkHelpIcon helpMessage="中小企業退職共済契約締結年月日から遡って直近３ヶ月以内に退職した職員については退職の事実が分かる証拠書類が必要となります。" />
      </>
    ),
    dontNeedSort: true,
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "中小企業退職共済契約締結年月日",
    keyword: "contractDate",
    type: "date",
    helpicon: true,
    requiredIcon: true,
    helpText:
      "中小企業退職金共済契約を締結した日です。直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
  },
  {
    title: "中小企業退職共済契約者番号",
    keyword: "contractNo",
    type: "label",
    helpicon: true,
    requiredIcon: true,
    helpText:
      "中小企業退職金共済契約における共済契約者番号を入力してください。",
    inputProps: { maxLength: 20 },
  },
  {
    title: "締結の理由",
    keyword: "contractReason",
    type: "label",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "当制度との契約を解除し、中小企業退職共済制度に加入される理由を具体的に入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "備考",
    keyword: "remark",
    type: "label",
    inputProps: { maxLength: 85 },
  },
  {
    keyword: "dateConfirmBtn",
    type: "node",
  },
  {
    title: "施設テーブル",
    keyword: "facilitySituationTable",
    type: "node",
  },
  {
    title: "説明文3",
    keyword: "infoManual3",
    type: "node",
  },
];

const schema = {
  contractDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  contractNo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[!-~]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0056E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 20,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
  contractReason: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  remark: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "85"),
    },
  },
};

export {
  stepperData,
  infoModalMessage,
  contextText,
  fakeTableList,
  schema,
  infoHeadTitleList,
};
